import type { EventParams } from "@/utils/analytics";

export type ConsentState = "granted" | "denied" | "unknown";

export type LeadEntryPoint = "home_hero" | "request_page";

export interface LeadAcceptedV1 {
  version: 1;
  leadId: string;
  conversionEventId: string;
  entryPoint: LeadEntryPoint;
  sourceUrl: string;
  submittedAt: string;
  consent: {
    analytics: ConsentState;
    advertising: ConsentState;
  };
  attributes?: EventParams;
}

export interface LeadMatchData {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
}

export type ConversionDeliveryStatus = "sent" | "skipped" | "failed";

export interface ConversionDeliveryResult {
  provider: string;
  channel: "browser" | "server";
  eventName: string;
  status: ConversionDeliveryStatus;
  eventId: string;
  recordedAt: string;
  reason?: string;
}

export interface LeadConversionAdapter {
  id: string;
  trackLead(event: LeadAcceptedV1, matchData?: LeadMatchData): Promise<ConversionDeliveryResult>;
}

export function createDeliveryResult(result: Omit<ConversionDeliveryResult, "recordedAt">): ConversionDeliveryResult {
  return { ...result, recordedAt: new Date().toISOString() };
}
